(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["alert~index"],{

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertProps", function() { return AlertProps; });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_BaseMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var _utils_vue_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _utils_getTransitionProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22);
/* harmony import */ var _utils_props_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);
/* harmony import */ var base_config_provider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import './style/index.scss';





 // import Base from '../base';

function noop() {}

var AlertProps = {
  /**
   * Type of Alert styles, options:`success`, `info`, `warning`, `error`
   */
  type: _utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].oneOf(['success', 'info', 'warning', 'error']),

  /** Whether Alert can be closed */
  closable: _utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].bool,

  /** Close text to show */
  closeText: _utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].any,

  /** Content of Alert */
  message: _utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].any,

  /** Additional content of Alert */
  description: _utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].any,

  /** Callback when close Alert */
  // onClose?: React.MouseEventHandler<HTMLAnchorElement>;

  /** Trigger when animation ending of Alert */
  afterClose: _utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].func.def(noop),

  /** Whether to show icon */
  showIcon: _utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].bool,
  iconType: _utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].string,
  prefixCls: _utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].string,
  banner: _utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].bool,
  icon: _utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].any
};
var Alert = {
  name: 'MegAlert',
  props: AlertProps,
  mixins: [_utils_BaseMixin__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  inject: {
    configProvider: {
      default: function _default() {
        return base_config_provider__WEBPACK_IMPORTED_MODULE_5__["ConfigConsumerProps"];
      }
    }
  },
  data: function data() {
    return {
      closing: false,
      closed: false
    };
  },
  methods: {
    handleClose: function handleClose(e) {
      e.preventDefault();
      var dom = this.$el;
      dom.style.height = "".concat(dom.offsetHeight, "px"); // Magic code
      // 重复一次后才能正确设置 height

      dom.style.height = "".concat(dom.offsetHeight, "px");
      this.setState({
        closing: true
      });
      this.$emit('close', e);
    },
    animationEnd: function animationEnd() {
      this.setState({
        closing: false,
        closed: true
      });
      this.afterClose();
    }
  },
  render: function render() {
    var _classNames;

    var h = arguments[0];
    var customizePrefixCls = this.prefixCls,
        banner = this.banner,
        closing = this.closing,
        closed = this.closed;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('alert', customizePrefixCls);
    var closable = this.closable,
        type = this.type,
        showIcon = this.showIcon,
        icon = this.icon;
    var closeText = Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_4__["getComponentFromProp"])(this, 'closeText');
    var description = Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_4__["getComponentFromProp"])(this, 'description');
    var message = Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_4__["getComponentFromProp"])(this, 'message');
    console.log(icon); // banner模式默认有 Icon

    showIcon = banner && showIcon === undefined ? true : showIcon; // banner模式默认为警告

    type = banner && type === undefined ? 'warning' : type || 'info'; // closeable when closeText is assigned

    if (closeText) {
      closable = true;
    }

    var alertCls = classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), true), _defineProperty(_classNames, "".concat(prefixCls, "-closing"), closing), _defineProperty(_classNames, "".concat(prefixCls, "-with-description"), !!description), _defineProperty(_classNames, "".concat(prefixCls, "-no-icon"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-banner"), !!banner), _defineProperty(_classNames, "".concat(prefixCls, "-closable"), closable), _classNames));
    var closeIcon = closable ? h("a", {
      "class": "".concat(prefixCls, "-close-icon"),
      on: {
        "click": this.handleClose
      }
    }, [closeText ? h("span", {
      "class": 'meg-alert-close-text'
    }, [closeText]) : h("meg-icon", {
      attrs: {
        name: 'megui-close'
      }
    })]) : null;
    var transitionProps = Object(_utils_getTransitionProps__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])("".concat(prefixCls, "-slide-up"), {
      appear: false,
      afterLeave: this.animationEnd
    });
    return closed ? null : h("transition", transitionProps, [h("div", {
      directives: [{
        name: "show",
        value: !closing
      }],
      "class": alertCls
    }, [h("meg-icon", {
      directives: [{
        name: "show",
        value: showIcon
      }],
      attrs: {
        name: icon
      },
      "class": 'meg-alert-icon'
    }), h("span", {
      "class": "".concat(prefixCls, "-message")
    }, [message]), h("span", {
      "class": "".concat(prefixCls, "-description")
    }, [description]), closeIcon])]);
  }
};
/* istanbul ignore next */

Alert.install = function (Vue) {
  Vue.component(Alert.name, Alert);
};

/* harmony default export */ __webpack_exports__["default"] = (Alert);

/***/ })

}]);